import type { UIManager } from '@/Core/Managers/UI'
import React from 'react'

import { useRouteDocumentTitle } from '@/Ship/Hooks/useRouteDocumentTitle'

interface PublicLayoutTemplateProps {
    layoutContext?: UIManager
    children: React.ReactNode
}

export const PublicLayoutTemplate: React.FC<PublicLayoutTemplateProps> = ({ children }) => {
    // Назва вкладки = назва розділу (pageConfig.title поточної сторінки)
    useRouteDocumentTitle()
    return <>{children}</>
}
